/** Fallback turn arrow when there is no connected route geometry to draw. */

/**
 * Do not invent bridge orientation or supports from an under-bridge label.
 */
export function underBridgeTurnGuideSvg(side: 'left' | 'right'): string {
  const mirror = side === 'left' ? ' transform="translate(120 0) scale(-1 1)"' : '';
  const scene = `
    <path class="uturn-guide__route" d="M35 84V49 Q35 30 54 30H96" />
    <path class="uturn-guide__head" d="M85 20L96 30L85 40" />
  `;
  return `<svg class="uturn-guide structure-guide structure-guide--under-bridge-turn" viewBox="0 0 120 96" aria-hidden="true" fill="none"><g${mirror}>${scene}</g></svg>`;
}
